module.exports = __webpack_public_path__ + "static/ArchivoNarrow-Regular-3c8f12762536afb8846cf1cb11acbc58.woff2";